import { Component, OnInit, Input } from '@angular/core';
import { DriversService } from 'src/app/drivers/services/drivers.service';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';

@Component({
  selector: 'app-user-drivers-config',
  templateUrl: './user-drivers-config.component.html',
  styleUrls: ['./user-drivers-config.component.scss', './../components-conf.scss']
})
export class UserDriversConfigComponent implements OnInit {
  @Input() filterOptionsBy : string = ""
  
  public columnOptions = [
    { label: 'Numeracion', value: 'index' },
    { label: 'Nombre', value: 'name' },
    { label: 'Identificacion', value: 'indentificate' },
    { label: 'Configuracion', value: 'edit' }
  ]
  public selectedColumns : any[] = [];
  public configSections = configSections;

  constructor(
    public driverService : DriversService
  ) { }

  ngOnInit(): void {
    this.selectedColumns = Object.keys(this.driverService.configuration.tableColumns)
      .filter(key => this.driverService.configuration.tableColumns[key]);
  }

  
  public updateVisibleColumns() {
    Object.keys(this.driverService.configuration.tableColumns).forEach(key => {
      this.driverService.configuration.tableColumns[key] = false;
    });

    this.selectedColumns.forEach((column)=>{
      this.driverService.configuration.tableColumns[column] = true
    })
  }
}
